<template>
  <div class="section-tags" :class="{concept: isConcept}" v-if="showSection">
    <div class="content-tag" 
      :class="['', 'big', 'small'][tag.style_type]"
      v-for="tag, index in sectionData" 
      :key="index"
      v-theme.self="tag.tag_style.theme"
      :style="tag.tag_style.style"
      @click="executeTagProtocol(tag)"
    >
      <img :src="tag.icon" alt="" class="content-tag-icon">
      <span class="content-tag-text"
        v-theme.self="tag.color_stype.theme"
        :style="tag.color_stype.style"
      >{{tag.text}}</span>
      <div class="static-color-suffix-tag" v-if="tag.sublabel" :style="tag.suffix_style">
        <span>{{tag.sublabel.sub_title}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { executeProtocolOutApp } from '_lib/utils'
export default {
  props: {
    linkInfo: {
      type: Object,
      default: () => ({}),
    },
    isConcept: {
      type: Boolean,
      default: false
    },
    showSpecialTag: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    onClickHotListTag () {
      executeProtocolOutApp({
        protocol_type: "openRouterPath",
        path: "home/rank_single"
      })
    },
    hashtagBackgroundColor (tag) {
      return {
        background: `linear-gradient(45deg, ${tag?.start_color}, ${tag?.end_color})`
      }
    },
    openHashTag (tag) {
      if (tag.protocol) {
        executeProtocolOutApp(tag.protocol)
      } else {
        executeProtocolOutApp({
          protocol_type: 'openBBSTag',
          tag: tag.name
        })
      }
    },
    linkToTopic(topic) {
      if (topic.topic_id == 58144) return

      executeProtocolOutApp({
        "protocol_type": "openTopic",
        "topic_id": topic.topic_id || topic.id,
        "topic_name": topic.name,
        "app_id": topic.app_id || topic.appid,
        "game_type": topic.game_type,
        "page": "link"
      })
    },
    executeTagProtocol ({protocol}) {
      executeProtocolOutApp(protocol)
    }
  },
  computed: {
    showSection () {
      return this.linkInfo.content_tags || this.linkInfo.hot_news_rank || this.linkInfo.topics || this.linkInfo.hashtags
    },
    sectionData () {
      let list = this.linkInfo.content_tags.filter(item => {
        return this.isConcept || item.align == (this.showSpecialTag ? 'top' : 'bottom')
      })
      return list.map(tag => {
        return {
          tag_style: getThemeColor('background', tag.bg_color),
          color_stype: getThemeColor('color', tag.text_color),
          suffix_style: {
            background: `linear-gradient(45deg, ${tag?.sublabel?.start_color}, ${tag?.sublabel?.end_color})`
          },
          ...tag
        }
      })
    },
  }
}

function getThemeColor (attr, arpg_color) {
  switch (arpg_color.match(/#/g)?.length || 0) {
    case 2: {
      let regx = /#[^#]*/g, color, light, dark
      while (color = regx.exec(arpg_color)) {
        if (!light) {
          light = handleARPG(color[0])
        } else {
          dark = handleARPG(color[0])
        }
      }
      return {
        theme: {
          light: {},
          dark: {}
        },
        style: {
          [attr]: light
        }
      }
    }
    case 1: {
      return {
        theme: {
          light: {},
          dark: {}
        },
        style: {
          [attr]: handleARPG(arpg_color),
        }
      }
    }
    case 0: {
      return {
        theme: {
          light: {},
          dark: {}
        },
        style: {
          [attr]: handleARPG(`#${arpg_color}`)
        }
      }
    }
    default: {
      throw new Error('错误的格式')
    }
  }
}

function handleARPG (color) {
  if (color.length == 9) {
    return `#${color.slice(3, 9)}${color.slice(1, 3)}`
  } else {
    return color
  }
}
</script>
<style lang="less">
.section-tags {
  display: flex;
  flex-wrap: wrap;
  padding: 0 12px;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  background-color: #ffffff;
  font-size: 0px;
  .content-tag {
    display: inline-flex;
    align-items: center;
    height: 24px;
    padding: 0 8px;
    margin: 0 10px 10px 0;
    border-radius: 3px;
    &.big {
      .content-tag-icon {
        width: 16px;
        height: 16px;
      }
      .content-tag-text {
        margin-left: 6px;
      }
    }
    &.small {
      .content-tag-icon {
        width: 12px;
        height: 12px;
      }
      .content-tag-text {
        margin-left: 3px;
      }
    }
    .content-tag-icon {
      border-radius: 2px;
      object-fit: cover;
    }
    .content-tag-text {
      margin-left: 3px;
      font-size: 12px;
      line-height: 24px;
      font-family: "PingFang SC";
    }
    .static-color-suffix-tag {
      position: relative;
      width: 12px;
      height: 12px;
      margin-left: 4px;
      border-radius: 2px;
      line-height: 12px;
      font-size: 10px;
      color: #ffffff;
      span {
        position: absolute;
        top: 0;
        left: 0;
        width: 200%;
        height: 200%;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        transform: scale(.5);
        transform-origin: left top;
      }
    }
  }
}
@media only screen and (max-width: 640px) {
  .section-tags {
    padding: 0 12px;
  }
}

</style>